import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useMutation, useQuery } from '@apollo/client'
import moment from 'moment'
import { InView } from 'react-intersection-observer'
import Loader from '../../Global/Spinner'
import { useLoading } from '../../../LoadingOverlay/LoadingOverlayContext'
import {
  COUNT_MIGRANTS_NOTIFICATIONS,
  MARK_ALL_MIGRANTS_NOTIFICATIONS_AS_READ,
  UPDATE_VIEWED_MIGRANTS_NOTIFICATION,
  USER_MIGRANTS_NOTIFICATIONS,
} from '../../../graphql/Catalog/Migrants/migrantsNotifications'

export const limitMaxNotification = 10

const MigrantsNotifications = ({ typeMarkAllAsRead, setTypeMarkAllAsRead }) => {
  const history = useHistory()
  const { showLoading, hideLoading } = useLoading()

  //STATES:
  const [isMore, setIsMore] = useState(true)
  const [notificationSelected, setNotificationSelected] = useState(null)

  //MUTATIONS:
  const [updateViewedNotification] = useMutation(
    UPDATE_VIEWED_MIGRANTS_NOTIFICATION,
    {
      refetchQueries: [{ query: COUNT_MIGRANTS_NOTIFICATIONS }],
    }
  )

  const [markAllNotificationsAsRead] = useMutation(
    MARK_ALL_MIGRANTS_NOTIFICATIONS_AS_READ,
    { refetchQueries: [{ query: COUNT_MIGRANTS_NOTIFICATIONS }] }
  )

  //QUERIES:
  const { loading, data, refetch, fetchMore } = useQuery(
    USER_MIGRANTS_NOTIFICATIONS,
    {
      variables: {
        limit: limitMaxNotification,
        offset: 0,
      },
      fetchPolicy: 'network-only',
    }
  )

  useEffect(() => {
    if (notificationSelected) {
      const splitLink = notificationSelected.link.split('/')
      const profileIndex = splitLink.indexOf('profile')

      if (profileIndex > 0) {
        const ratingId = splitLink[profileIndex + 1]
        const baseSegments = splitLink.slice(0, profileIndex + 1)
        console.log(baseSegments, 'baseSegments')
        const newRoute = `${baseSegments.join('/')}`
        console.log(newRoute, 'newRoute')
        localStorage.setItem('ratingId', JSON.stringify(ratingId))
        history.push(newRoute)
      }
    }
  }, [notificationSelected])

  const handleClick = async (item) => {
    showLoading()
    try {
      const type = item?.notification_type || 'default'
      await updateViewedNotification({ variables: { id: parseInt(item.id) } })
      setIsMore(true)
      refetch()
      if (type === 'rating') setNotificationSelected(item)
      if (item?.link && type === 'reports') history.push(item.link)
    } catch (error) {
    } finally {
      hideLoading()
    }
  }

  const handleMarkAllAsRead = async () => {
    if (!loading && data?.all && data?.all.length === 0) return false

    showLoading()
    try {
      await markAllNotificationsAsRead({
        variables: { query: typeMarkAllAsRead },
      })
      setIsMore(true)
      refetch()
      setTypeMarkAllAsRead(null)
    } catch (error) {
    } finally {
      hideLoading()
    }
  }

  useEffect(() => {
    if (['All', 'BeforeCurrentDate'].includes(typeMarkAllAsRead)) {
      handleMarkAllAsRead()
    }
  }, [typeMarkAllAsRead])

  return (
    <>
      {loading && <Loader size="1rem" />}

      {!loading && data?.all && data?.all.length > 0 && (
        <>
          <ul className="sideBarRight-notifications px-1 mb-0">
            {data.all.map((item) => {
              return (
                <li
                  key={item.id}
                  className="sideBarRight-notification d-flex"
                  onClick={() => handleClick(item)}
                >
                  <div className="icon bg-gray">
                    <i
                      // className="fas fa-file"
                      className={`${
                        item.notification_type === 'reports'
                          ? 'fas fa-file'
                          : 'fas fa-star'
                      }`}
                    />
                  </div>
                  <div className="boxMessage">
                    <span className="message">{item.message}</span>
                    <div className="boxDate d-flex justify-content-between">
                      {(item?.timeDiff || item?.dayDif) && (
                        <span className="dateDif mr-1">
                          {item?.dayDif && <span>{item?.dayDif}</span>}
                          {item?.timeDiff && item?.dayDif && ` - `}
                          {item?.timeDiff && <span>{item?.timeDiff}</span>}
                        </span>
                      )}
                      {moment(item.createdAt).format('DD/MM/YYYY')}
                    </div>
                  </div>
                  <div className="iconViewed">
                    <i className="fas fa-circle text-blue" />
                  </div>
                </li>
              )
            })}
            {data && (
              <InView
                as="div"
                onChange={(inView) => {
                  if (inView && isMore) {
                    fetchMore({
                      variables: {
                        limit: limitMaxNotification,
                        offset: data?.all.length,
                      },
                      updateQuery: (prev, { fetchMoreResult }) => {
                        if (!fetchMoreResult) {
                          setIsMore(false)
                          return prev
                        }
                        if (fetchMoreResult.all.length === 0) {
                          setIsMore(false)
                          return prev
                        }

                        setIsMore(true)
                        return {
                          ...prev,
                          all: [...prev.all, ...fetchMoreResult.all],
                        }
                      },
                    })
                  }
                }}
              >
                <div className="invisible">Cargando...</div>
              </InView>
            )}
          </ul>
        </>
      )}

      {!loading && data?.all && data?.all.length === 0 && (
        <div
          className="text-muted text-center pt-3 pb-2"
          style={{ fontSize: 12 }}
        >
          No hay notificaciones
        </div>
      )}
    </>
  )
}

export default MigrantsNotifications
